import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import './CreateSuccess.scss'
import InsCreateSuccess from './InsCreateSuccess/InsCreateSuccess';
//import { store } from '../../../store/configureStore';
import { connect } from 'react-redux'
import InsLoader from '../../../components/InsLoader/InsLoader';
import LogoCustomTheme from 'components/Theme/Logo/LogoCustomTheme';

class CreateSuccess extends Component {

  constructor(props){
    super(props);
    this.state = {
      step: 0 //gérer le loader
    }
  }

  render() {
    const { t, history } = this.props
    const firstname = this.props.userInfo.userInfo.firstname
    

      //redirection si l'utilisateur arrive sur la page par url ou par historique
      if(!this.props.location.state || this.props.location.state.isCreated === undefined){
        return (<Redirect to="/" />)
      }

      //logique illusion de loading
      if(this.state.step === 0){
        setTimeout(() => {
          this.setState({
            step:1
          })
        }, 3000)
      }

      //chargement du bon composant en fonction du resultat de la requete api
      if(this.state.step === 1){
        
        //Nous ne parvenons à trouver votre profil pour le moment.
        if(!this.props.location.state.isCreated){
          return (
            <div className="default-container col-flex">
              <div className="mv20">
                <LogoCustomTheme className='we-are-ll' />
              </div>
    
                <InsCreateSuccess
                img="info"
                approved={this.props.location.state.isCreated}
                link="/connect"
                textLink={t('back_to_home')}
                history={history}
                />
      
              <div className="bottom-container"></div>
            </div>
          )
        }
        //Nous parvenons à trouver votre profil.
        if(this.props.location.state.isCreated){
          return (
            <div className="default-container col-flex">
              <div className="mv20">
                <LogoCustomTheme className='we-are-ll' />
              </div>
      
              <InsCreateSuccess 
              img="check"
              name={firstname}
              approved={this.props.location.state.isCreated}
              link="/"
              textLink={t('access_to_app')}
              approuved={true}
              history={history}
              />

              <div className="bottom-container"></div>
            </div>
          )
        }

      }

      //affichage illusion de loading
      else{

        return (
          <div className="default-container col-flex">
          <div className="mv20">
            <LogoCustomTheme className='we-are-ll' />
          </div>
          <div className="account-check-content col-flex">
            <InsLoader/>
            <div className='account-check-text'>
              <p>{t('search_profile_text')}</p>
              <p>{t('wait_please')}</p>
            </div>
          </div> 
        </div>
        )

      }      
    }
  }

  const mapStateToProps = (state) => ({
    userInfo: state.createAccount,
  })
  
  const mapDispatchToProps  = () => {
  }

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CreateSuccess))